import { makeStyles } from '@material-ui/styles';

import { grey750 } from '../../ThemeProvider';

export const useStyles = makeStyles(({ palette }) => ({
    content: {
        marginLeft: '8px',
        flex: 0,
        minWidth: '84px',
    },
    paper: {
        marginBottom: '1px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '42px',
        minWidth: '78px',
        backgroundColor: palette.type === 'light' ? palette.grey['300'] : grey750,
        border: `1px solid ${palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : palette.borderColor}`,

        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        userSelect: 'none',
    },
    switchMeasure: {
        height: '42px',
        minWidth: '78px',
    },
}));
